"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledControlsItem = exports.StyledNoZoomSelect = exports.StyledControlsLayout = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledControlsLayout = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, space = _b.space, mediaQueries = _b.mediaQueries;
    return "\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: -".concat(space[4], ";\n\n    ").concat(mediaQueries.smallAndUp, " {\n        margin-bottom: -").concat(space[8], ";\n    }\n");
});
// https://stackoverflow.com/questions/6483425/prevent-iphone-from-zooming-in-on-select-in-web-app
exports.StyledNoZoomSelect = styled_components_1.default.select(function (_a) {
    var responsiveFontSizes = _a.theme.responsiveFontSizes;
    return "\n    font-size: ".concat(responsiveFontSizes.body[1], ";\n  ");
});
exports.StyledControlsItem = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, space = _b.space, mediaQueries = _b.mediaQueries;
    return "\n    margin-bottom: ".concat(space[4], ";\n    margin-right:").concat(space[4], ";\n\n    ").concat(mediaQueries.smallAndUp, " {\n        margin-bottom: ").concat(space[8], ";\n        margin-right:").concat(space[8], ";\n    }\n\n    &:last-child {\n        margin-right: 0;\n    }\n");
});
